import LiquidacaoFiltro from '../../produto/spa/liquidacao-acao/LiquidacaoFiltro';

export default LiquidacaoFiltro;
